import { gql } from '@apollo/client';

export const quoteBlockFragment = gql`
  fragment quoteBlock on QuoteBlock {
    __typename
    sys {
      ...sys
    }
    tagline
    heading
    description
    mediaItem {
      ...mediaImage
      ...mediaVideo
    }
    quoteItemsCollection(limit: 10) {
      items {
        quote
        name
        title
      }
    }
    primaryCta {
      ...cta
    }
  }
`;
